import React from 'react';
import {
    Route,
    Redirect
  } from "react-router-dom";
import {ACCESS_TOKEN } from '../constants';  
  
const LoginSessionRoute = ({ component: Component, authenticated, ...rest }) => (
    <Route
      {...rest}
      render={props =>
        localStorage.getItem(ACCESS_TOKEN) ? (
          (<Redirect to={{pathname: '/dashboard',state: { from: props.location }}}/>)
        ) : (<Redirect to={{pathname: '/',state: { from: props.location }}}/>)
      }
    />
);
  
export default LoginSessionRoute